module.exports = __webpack_public_path__ + "img/banner-sobre-vaga.318e2915.png";